export const environment: any = {
    production: true,
    jsonConfig: 'config.json'
};



// WEBPACK FOOTER //
// ./src/environments/environment.ts